import { SectionHeader } from "./SectionHeader";
import {
  IconDashboard, IconInventory, IconSales, IconAI, IconStats,
  IconCloud, IconSecurity, IconFast, IconDevices,
} from "./FeatureIcons";

const FEATURES = [
  { Icon: IconDashboard, title: "Dashboard financiero", desc: "Visualiza ingresos, gastos y ganancias en tiempo real." },
  { Icon: IconInventory, title: "Inventario", desc: "Controla tu stock y recibe alertas cuando se esté agotando." },
  { Icon: IconSales, title: "Ventas", desc: "Registra ventas de contado y a crédito en segundos." },
  { Icon: IconAI, title: "Inteligencia Artificial", desc: "Pregúntale a la IA sobre tu negocio y obtén respuestas claras." },
  { Icon: IconStats, title: "Estadísticas", desc: "Reportes visuales para entender cómo va tu negocio." },
  { Icon: IconCloud, title: "Sincronización en la nube", desc: "Tu información disponible desde cualquier dispositivo." },
  { Icon: IconSecurity, title: "Seguridad con Firebase", desc: "Tus datos protegidos con la infraestructura de Google." },
  { Icon: IconFast, title: "Funciona sin instalar", desc: "Úsala directamente desde el navegador, sin fricciones." },
  { Icon: IconDevices, title: "Compatible con todo", desc: "Android, iPhone, tablet y computador, en un solo lugar." },
];

export default function Features({ C }) {
  return (
    <section style={{ padding: "64px 20px", maxWidth: 1080, margin: "0 auto" }}>
      <SectionHeader C={C} eyebrow="Características" title="Todo lo que tu negocio necesita" />
      <div className="cq-grid-3" style={{ display: "grid", gap: 16, marginTop: 36 }}>
        {FEATURES.map(({ Icon, title, desc }, i) => (
          <div
            key={title}
            style={{
              background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: 18,
              padding: 22, boxShadow: C.shadow, transition: "transform 0.2s, border 0.2s",
              animation: `fadeIn 0.5s ease ${i * 0.04}s backwards`,
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.borderColor = C.borderHi; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.borderColor = C.border; }}
          >
            <div style={{
              width: 42, height: 42, borderRadius: 12, marginBottom: 14,
              background: `${C.primary}18`, display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <Icon color={C.primary} size={21} />
            </div>
            <div style={{ color: C.text, fontWeight: 700, fontSize: 15, marginBottom: 6 }}>{title}</div>
            <div style={{ color: C.muted, fontSize: 13, lineHeight: 1.5 }}>{desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
}